import { Col, Container, Row } from 'react-bootstrap';
import LogoFooter from '../../Atoms/LogoFooter/LogoFooter';
import ModalPolicies from '../Modals/ModalPolicies/ModalPolicies';
import ModalTerms from '../Modals/ModalTerms/ModalTerms';
import iconTelephone from "../../../Resources/Images/Footer/icon_telephone.svg";
import "./Footer.css";

import useIsMobile from "../../../Hooks/useIsMobile";



function Footer() {
  const isMobile = useIsMobile()

  return (
    <>
      <footer className='container__footer' >
        <Row className={`justify-content-center align-items-center my-3 mx-0 p-0 ${isMobile && 'mb-3'}`}>
          <Col className='col-12 col-md-auto my-4'>
            <LogoFooter />
          </Col>
          <Col className={`${isMobile ? 'col-5 p-0 my-1':'col-auto my-5'}`}>
            <ModalTerms 
              class__link__modal={'texto__footer'}
            />
          </Col>
          <Col className={`${isMobile ? 'col-5 p-0 my-1':'col-auto my-5'}`}>
            <ModalPolicies 
              class__link__modal={'texto__footer'}
            />
          </Col>
          <Col className='col-auto my-4 d-none d-md-block'>
            <span className='texto__footer'>
              BNP Paribas Cardif Derechos reservados Copyright © 2023
            </span>
          </Col>
        </Row>
        <Row className='justify-content-center my-4 mx-0 p-0'>
          <Col className={`col-12 col-md-8 text-center ${isMobile && 'px-3'}`}>
            <p className='texto__footer'>
              ASSA Compañía de Seguros S.A. es una empresa debidamente regulada y supervisada por la Superintendencia de Seguros y Reaseguros de Panamá, y Cardif Colombia Seguros Generales S.A. es una compañía inscrita dentro del Registro Obligatorio de Reaseguradoras Extranjeras no establecida en la República de Panamá.            </p>
          </Col>
        </Row>         
        <Row className='justify-content-center align-items-center my-5 mx-0 p-0'>
          <Col className='col-auto p-0'>
            <p className='texto__footer'>
              En caso de requerir información adicional o presentar {isMobile && (<br></br>)} algún inconveniente, comunícate con {isMobile && (<br></br>)} nuestras líneas de atención:
            </p>
          </Col>
        </Row> 
        <Row className='justify-content-center align-items-center my-1 mx-0 p-0'>
          <Col className='col-auto p-2'>
            <img width={17} height={17} alt="ícono teléfono" src={iconTelephone}></img>
          </Col>
          <Col className='col-auto p-0'>
            <p className='texto__footer'>
              (507) 833-9009
            </p>
          </Col>
        </Row>
        <Row className='justify-content-center align-items-center my-1 mx-0 p-0'>
          <Col className='col-auto p-0 mb-4'>
            <p className='texto__footer'>
              comunicaciones@cuentacontuseguro.com
            </p>
          </Col>
        </Row>         
        <Row className='w-100 justify-content-center align-items-center m-0 p-0 background__footer'>
          <Col className='col-12 text-center p-0'>
            <p className='texto__banner__footer'>
              Para que vivas una mejor experiencia y visualizar nuestros servicios, te recomendamos usar los navegadores de internet “Web Chrome 43”, ”Firefox 38”, ”Safari 8” o sus versiones más actualizadas
            </p>
          </Col>
        </Row>
      </footer>
      <Container fluid className='px-0'>
      </Container>
    </>
  );
}

export default Footer;